<template>
	<div class="authPage__passwordStrengthMeter">
		<div class="authPage__passwordRuleItem">
			<div
				class="authPage__passwordRuleCheck"
				:class="{
					'is-checked': hasMinLength(password),
				}"
			>
				<BIcon
					class="authPage__passwordRuleCheckIcon"
					name="Checkmark"
					size="12px"
				/>
			</div>
			{{ $t("Mínimo 8 carateres") }}
		</div>

		<div class="authPage__passwordRuleItem">
			<div
				class="authPage__passwordRuleCheck"
				:class="{
					'is-checked': hasUppercase(password),
				}"
			>
				<BIcon
					class="authPage__passwordRuleCheckIcon"
					name="Checkmark"
					size="12px"
				/>
			</div>
			{{ $t("Letras maiúsculas") }}
		</div>

		<div class="authPage__passwordRuleItem">
			<div
				class="authPage__passwordRuleCheck"
				:class="{
					'is-checked': hasLowercase(password),
				}"
			>
				<BIcon
					class="authPage__passwordRuleCheckIcon"
					name="Checkmark"
					size="12px"
				/>
			</div>
			{{ $t("Letras minúsculas") }}
		</div>

		<div class="authPage__passwordRuleItem">
			<div
				class="authPage__passwordRuleCheck"
				:class="{
					'is-checked': hasSpecialChar(password),
				}"
			>
				<BIcon
					class="authPage__passwordRuleCheckIcon"
					name="Checkmark"
					size="12px"
				/>
			</div>
			{{ $t("Carater especial") }}
		</div>

		<div class="authPage__passwordRuleItem">
			<div
				class="authPage__passwordRuleCheck"
				:class="{
					'is-checked': hasNumber(password),
				}"
			>
				<BIcon
					class="authPage__passwordRuleCheckIcon"
					name="Checkmark"
					size="12px"
				/>
			</div>
			{{ $t("Carater numérico") }}
		</div>
	</div>
</template>

<script>
import BIcon from "@/components/base/BIcon";

function hasMinLength(val) {
	return val.length >= 8;
}
function hasUppercase(val) {
	return /[A-Z]/.test(val);
}

function hasLowercase(val) {
	return /[a-z]/.test(val);
}

function hasSpecialChar(val) {
	/* eslint-disable-next-line */
	const regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
	return regex.test(val);
}
function hasNumber(val) {
	return /[0-9]/.test(val);
}

function isPasswordValid(val) {
	return (
		hasMinLength(val) &&
		hasUppercase(val) &&
		hasLowercase(val) &&
		hasSpecialChar(val) &&
		hasNumber(val)
	);
}

export { isPasswordValid };

export default {
	components: {
		BIcon,
	},
	props: {
		password: {
			type: String,
			required: true,
		},
	},
	methods: {
		hasMinLength,
		hasUppercase,
		hasLowercase,
		hasSpecialChar,
		hasNumber,
		isPasswordValid,
	},
};
</script>
